import ValidationService from 'services/ValidationService'
import dayjs from 'dayjs'

export function ucfirst(text) {
    return text.charAt(0).toUpperCase() + text.substr(1)
}

export function importComponents(files, except = []) {
    const components = {}

    files
        .keys()
        .filter((file) => file.split('/').length === 2) // Ignore nested components.
        .forEach((file) => {
            const component = file.replace(/(\.\/|\.vue)/g, '')

            if (except.includes(component)) {
                return
            }

            components[component] = files(file).default
        })

    return components
}

export function simulateApiCall(response, maxTime = 1000) {
    return new Promise((resolve) => setTimeout(() => resolve(response), Math.floor(Math.random() * maxTime) + maxTime / 10))
}

export function simulateValidationError(errors) {
    ValidationService.set(errors)

    return Promise.reject({
        response: {
            status: 400,
            data: { code: 'validation_failed', errors },
        },
    })
}

export function isRouteNameEqual(firstRouteName, secondRouteName, comparisonDepth = 1) {
    const firstRouteChunks = firstRouteName ? firstRouteName.split('.').slice(0, comparisonDepth) : ['']
    const secondRouteChunks = secondRouteName ? secondRouteName.split('.').slice(0, comparisonDepth) : ['']
    return firstRouteChunks.join('.') === secondRouteChunks.join('.')
}

export function matchFullRoute(targetRoute, currentRoute, comparisonDepth = 1) {
    if (!isRouteNameEqual(targetRoute.name, currentRoute.name, comparisonDepth)) {
        return false
    }
    const targetQuery = targetRoute.query || {}
    const currentQuery = currentRoute.query || {}
    const targetKeys = Object.keys(targetQuery)

    // When a route is registered without query keys, treat siblings as those routes that
    // explicitly carry a `locationId` (the discriminator for availability sub-items).
    // This keeps the "Main Location" item highlighted regardless of extra UI params like `date`/`view`.
    if (targetKeys.length === 0) {
        return !currentQuery.locationId
    }

    return targetKeys.every((key) => String(targetQuery[key]) === String(currentQuery[key]))
}

export function dateFormate(date) {
    if (!date) return ''

    const d = dayjs(date)
    if (!d.isValid()) return ''

    return d.format('MM-DD-YYYY')
}
